import _ from 'lodash';
import jwtDecode from 'jwt-decode';
import {
  REGISTER_USER_SUCCESS, LOGIN_USER_SUCCESS, SAVE_USER_PROFILE, 
} from '../constants';

const defaultState = {
  identityToken: null,
  accessToken: null,
  refreshToken: null,
  identity: {},
  asi: null,
  userData: { phone: '' },
  selectedAddress: null,
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case REGISTER_USER_SUCCESS:
      const {
        accessToken, identityToken, refreshToken, userDataParsed, 
      } = action.payload;

      const decodedIdentityToken = jwtDecode(identityToken);
      return {
        ...state,
        identityToken,
        accessToken,
        refreshToken,
        identity: decodedIdentityToken,
        userData: userDataParsed,
      };

    case LOGIN_USER_SUCCESS:
      const accessTokenLogin = _.get(action, 'payload.accessToken', false);
      const identityTokenLogin = _.get(action, 'payload.identityToken', false);
      const refreshTokenLogin = _.get(action, 'payload.refreshToken', false);
      const decodedIdentityTokenLogin = jwtDecode(identityTokenLogin);
      return {
        ...state,
        identityToken: identityTokenLogin,
        accessToken: accessTokenLogin,
        refreshToken: refreshTokenLogin,
        identity: decodedIdentityTokenLogin,
      };
    case SAVE_USER_PROFILE:
      const { userData } = action.payload;
      const addressIso = _.get(userData, 'address_iso', false);
      let selectedAddress = null;
      if (addressIso) {
        selectedAddress = addressIso.split('|').join(' ');
      }
      return {
        ...state,
        userData,
        selectedAddress,
      };
    default:
      return { ...state };
  }
};
